<template>
  <div>
    <div class="page px-3" v-if="mainSection === true">
      <!-- Second Modal -->
      <div class="modal fade" id="secondModal" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1"
           aria-labelledby="staticMainDebtorBackdrop1Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="secondModalLabel">Deny Request</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-2">
                <label for="Reason" class="fw-bold">Reason</label>
                <input type="text" placeholder="Reason" class="form-control" id="Reason" v-model="reason">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="DenyRequest">Deny</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs for User Requests and Wallet Requests -->
      <!--    <div class="tabs">-->
      <!--      <button :class="{'active': activeTab === 'user'}" @click="setTab('user')">User Requests</button>-->
      <!--      <button :class="{'active': activeTab === 'wallet'}" @click="setTab('wallet')">Wallet Requests</button>-->
      <!--    </div>-->

      <div class="section">
        <div style="width:100%; display:flex; justify-content: space-between; align-items:center">
          <h4 v-if="activeTab === 'wallet'"
              :class="{'attention-required': totalAmount > 0}">
            Total : {{ $utils.formatMoney(totalAmount) }}
          </h4>
          <h4 v-if="activeTab === 'user'"
              :class="{'attention-required': totalAmount > 0}">
            Total : {{ $utils.formatMoney(totalAmount) }}
          </h4>
          <div style="display: flex">
            <ApproveButton
                buttonText="Batch"
                @click="showApproveModal(); refillVueTable();"
            />
            <ApproveButton
                buttonText="Reports"
                @click="activateReportSection(); getReports();"
            />
          </div>
        </div>
        <div class="row gap-1">
          <div class="card col-md-4"
               v-for="(item, index) in filteredCardData"
               :key="index"
          >
            <div>
              <div class="d-flex flex-row justify-content-between">
                <div class="d-flex flex-column mx-3" v-if="item.hasImage">
                  <img src="../assets/img/no-image.png" v-gallery
                       :data-large="pettyCashApi+`getImageByRequestID/${item.id}`" alt="Product Image" width="60"
                       height="60"/>
                  <span class="text-secondary " style="font-size: 12px">(Click to View)</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="text-secondary"><strong>ID:</strong> {{ item.id }}</span>
                  <p>{{ item.subType }}</p>
                  <p>{{ item.requestedWallet }}</p>
                </div>
                <a @click="acceptRequestOnlyExpense(item)">
                  <font-awesome-icon icon="money-bill"/>
                </a>
              </div>
              <div class="product-info">
                <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                <span v-if="item.reference">{{ item.reference }}<br>({{ item.provider }})</span>
              </div>
            </div>
            <div class="card-body d-flex flex-column">
              <span class="fw-bolder mb-1" style="font-size: 20px" >{{ item.requestBy }}</span>
              <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
              <span class="card-text mb-1"><strong>Department:</strong> {{ item.department }}</span>
              <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
              <span class="card-text mb-1" v-if="item.type === 'SHIPPING'"><strong>Supplier:</strong> {{ item.supplier || 'N/A' }}</span>
              <span class="card-text mb-1" v-if="item.type === 'SHIPPING'"><strong>Store:</strong> {{ item.storeId || 'N/A' }}</span>
              <span class="card-text mb-1" v-if="item.type === 'SHIPPING'"><strong>Invoice:</strong> {{ item.invoiceId || 'N/A' }}</span>
              <span class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
              <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
              <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
              <!--            <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.request_date }}</span>-->
            </div>
            <div class="d-flex flex-row justify-content-evenly">
              <button type="button" class="btn text-center w-50 mx-2 btn-success" @click="AcceptRequest(item)">Accept
              </button>
              <button type="button" class="btn text-center w-50 btn-danger" @click="DenyRequest(item)">Deny</button>
            </div>
          </div>
        </div>

        <!-- Empty state when no pending requests -->
        <div v-if="filteredCardData && filteredCardData.length === 0" class="text-center py-5">
          <font-awesome-icon icon="inbox" style="font-size: 3rem; color: #ccc;" />
          <p class="text-muted mt-3">No pending requests to approve</p>
        </div>

      </div>

      <!-- Modal -->
      <div class="modal fade" id="staticMainDebtorBackdrop1" data-bs-backdrop="false" data-bs-keyboard="false"
           tabindex="-1" aria-labelledby="staticMainDebtorBackdrop1Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="staticMainDebtorBackdrop1Label">Pay Expense</h6>
              <button type="button" class="btn-close" id="close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="selectedCard">
                <p v-if="activeTab === 'user'"><strong>Subtype:</strong> {{ selectedCard.subType }}</p>
                <p v-if="activeTab === 'user'"><strong>DEPARTMENT:</strong> {{ selectedCard.department }}</p>
                <p><strong>ID:</strong> {{ selectedCard.id }}</p>
                <p><strong>Amount:</strong> {{ selectedCard.amount }}</p>
                <p><strong>Reason:</strong> {{ selectedCard.reason }}</p>
                <p v-if="selectedCard.type === 'SHIPPING'"><strong>Supplier:</strong> {{ selectedCard.supplier || 'N/A' }}</p>
                <p v-if="selectedCard.type === 'SHIPPING'"><strong>Store:</strong> {{ selectedCard.storeId || 'N/A' }}</p>
                <p v-if="selectedCard.type === 'SHIPPING'"><strong>Invoice:</strong> {{ selectedCard.invoiceId || 'N/A' }}</p>
                <p v-if="activeTab === 'user'"><strong>Requested-By:</strong> {{ selectedCard.requestBy }}</p>
                <p v-if="activeTab === 'wallet'"><strong>Requested-By:</strong> {{ selectedCard.requestedBy }}</p>
                <p v-if="activeTab === 'user'"><strong>Phone Number:</strong> {{ selectedCard.reference }}</p>
                <p v-if="activeTab === 'user'"><strong>Date Requested:</strong> {{ selectedCard.requestDate }}</p>
                <p v-if="activeTab === 'wallet'"><strong>Date Requested:</strong> {{ selectedCard.request_date }}</p>
                <button type="button" class="btn btn-primary" @click="viewticket" v-if="selectedCard.type === 'JOBCARD'">
                  view Ticket
                </button>
                <button type="button" class="btn btn-primary" @click="openimage">view-image</button>
              </div>
            </div>
            <div class="modal-footer">

            </div>
          </div>
        </div>
      </div>
      <!--    <floating-add-button v-if="activeTab === 'user'" @click="openuser"/>-->
      <!--    <MakeWalletRequest v-if="activeTab === 'wallet'" :selectedWallet="selectedWallet" :wallets="wallets"/>-->


      <button class="hide" id="openCard" data-bs-toggle="modal" data-bs-target="#staticMainDebtorBackdrop1"></button>
      <div v-if="approveAllModal" class="modal-overlay">
        <div class="modal-content form-container">
          <div class="modal-header" v-if="isMobileView">
            <ApproveButton
                style="margin-right: 5px"
                :buttonText="isLoading ? 'Processing...' : 'Process'"
                :disabled="isLoading"
                @click="approveAll"
            />
            <ApproveButton
                buttonText="Close"
                buttonColor="black"
                hoverColor="#c82333"
                hoverTextColor="#ffffff"
                @click="closeApproveModal"
            />
            <div style="margin-left: 10px">
              <label>
                <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="toggleSelectAll"
                />
                All
              </label>
            </div>
          </div>
          <div class="modal-bodyy">
            <div v-if="isMobileView" class="card-container">
              <div class="card col-md-4"
                   style="width: 100%"
                   v-for="(item, index) in refillTableData"
                   :key="index"
              >
                <div>
                  <div class="d-flex flex-row justify-content-between">

                    <div class="d-flex flex-column">
                      <p>{{ item.subType }}</p>
                    </div>
                    <div class="d-flex flex-column mx-3">
                      <img
                          v-if="item.massage === 'Success'"
                          src="@/assets/img/check.png"
                          alt="Success"
                          class="img"
                      />
                      <img
                          v-else-if="item.massage && item.massage !== 'Success'"
                          src="@/assets/img/cancel.png"
                          alt="Error"
                          class="img"
                      />
                    </div>
                    <div class="card-item">
                      <label>
                        <input
                            type="checkbox"
                            :value="item.id"
                            v-model="selectedIds"
                        />
                        Select
                      </label>
                    </div>
                  </div>
                  <div class="product-info">
                    <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                  </div>
                </div>
                <div class="card-body d-flex flex-column" style="padding: 1px">
                  <!--                <button @click="checker(item)">CHECK</button>-->
                  <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
                  <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
                  <span class="card-text mb-1"><strong>Number:</strong> {{ item.reference }}</span>
                  <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
                  <span class="card-text mb-1"><strong>Subtype:</strong> {{ item.subType }}</span>
                  <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
                  <span class="card-text mb-1" v-if="item.massage"><strong>Massage:</strong> {{ item.massage }}</span>
                  <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                  <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                  <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
                </div>
              </div>
            </div>
            <vue-good-table
                v-else
                :columns="columns2"
                :rows="refillTableData"
                @on-selected-rows-change="selectionChanged"
                :search-options="{ enabled: true }"
                :select-options="{ enabled: true }"
                :pagination-options="{ enabled: true, perPage: 6 }"
                class="mt-2"
            >
              <!-- Custom slot for the images column -->
              <template slot="table-row" slot-scope="props">
                <!-- Render images in the custom 'status' column -->
                <td v-if="props.column.field === 'image'">
                  <img
                      v-if="props.row.massage === 'Success'"
                      src="@/assets/img/check.png"
                      alt="Success"
                      class="img"
                  />
                  <img
                      v-else-if="props.row.massage && props.row.massage !== 'Success'"
                      src="@/assets/img/cancel.png"
                      alt="Error"
                      class="img"
                  />
                </td>
                <!-- Render default content for other columns -->
                <td v-else>
                  {{ props.formattedRow[props.column.field] }}
                </td>
              </template>

              <div slot="selected-row-actions">
                <ApproveButton
                    buttonText="Approve selected"
                    @click="approveAll"
                />
              </div>
            </vue-good-table>
            <ApproveButton
                v-if="!isMobileView"
                buttonText="Close"
                buttonColor="black"
                hoverColor="#c82333"
                hoverTextColor="#ffffff"
                @click="closeApproveModal"
            />
          </div>
          <div class="total-amount" style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">
            Total Amount: {{ $utils.formatMoney(totalSelectedAmount) }}
          </div>
          <div v-if="isLoading" class="overlay">
            <section class="dots-container">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div class="page px-3" v-if="reportSection === true">
      <div style="width: 100%; display: flex; align-items: center; gap: 5px">
        <div class="back-nav" @click="activateMainSection">
          <div class="font-btn">
            <font-awesome-icon icon="fa-solid fa-angles-left" style="margin-bottom: 10px"/>
          </div>
        </div>
        <div class="range">
          <RangeSelector :submit-method="getReports"/>
        </div>
      </div>

      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
                  data-bs-target="#pending" type="button" role="tab" aria-controls="home"
                  aria-selected="true" @click="status2 = 'Pending'; getReports()">PENDING
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="home-tab" data-bs-toggle="tab"
                  data-bs-target="#declined" type="button" role="tab" aria-controls="home"
                  aria-selected="true" @click="status2 = 'Declined'; getReports()">REJECTED
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="profile-tab" data-bs-toggle="tab"
                  data-bs-target="#approved" type="button" role="tab" aria-controls="profile"
                  aria-selected="false" @click="status2 = 'Approved'; getReports()">APPROVED
          </button>
        </li>
      </ul>

      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="pending" role="tabpanel" aria-labelledby="home-tab">
          <div v-if="isMobileView" class="card-container">
            <div class="card col-md-4"
                 style="width: 100%"
                 v-for="(item, index) in report"
                 :key="index"
            >
              <div>
                <div
                    class="manager"
                    style="background-color: orange"
                >
                  <h6 class="h6-tag">PENDING</h6>
                </div>
                <div class="d-flex flex-row justify-content-between">

                  <div class="d-flex flex-column">
                    <p>{{ item.subType }}</p>
                  </div>
                </div>
                <div class="product-info">
                  <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                </div>
              </div>
              <div class="card-body d-flex flex-column" style="padding: 1px">
                <!--                <button @click="checker(item)">CHECK</button>-->
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
                <span class="card-text mb-1"><strong>Number:</strong> {{ item.reference }}</span>
                <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
<!--                <span class="card-text mb-1"><strong>Subtype:</strong> {{ item.subType }}</span>-->
                <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
                <span class="card-text mb-1" v-if="item.massage"><strong>Massage:</strong> {{ item.massage }}</span>
                <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
              </div>
            </div>
          </div>
          <vue-good-table
              v-else
              :columns="pendingTable"
              :rows="report"
              :pagination-options="{ enabled: true, perPage: 10 }"
              styleClass="vgt-table striped bordered condensed"
          >
          </vue-good-table>
        </div>

        <div class="tab-pane fade show" id="declined" role="tabpanel" aria-labelledby="home-tab">
          <div v-if="isMobileView" class="card-container">
            <div class="card col-md-4"
                 style="width: 100%"
                 v-for="(item, index) in report"
                 :key="index"
            >
              <div>
                <div
                    class="manager"
                    style="background-color: red"
                >
                  <h6 class="h6-tag">REJECTED</h6>
                </div>
                <div class="d-flex flex-row justify-content-between">

                  <div class="d-flex flex-column">
                    <p>{{ item.subType }}</p>
                  </div>
                  <div class="d-flex flex-column mx-3">
                  </div>
                </div>
                <div class="product-info">
                  <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                </div>
              </div>
              <div class="card-body d-flex flex-column" style="padding: 1px">
                <!--                <button @click="checker(item)">CHECK</button>-->
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
                <span class="card-text mb-1"><strong>Number:</strong> {{ item.reference }}</span>
                <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
                <span class="card-text mb-1"><strong>Subtype:</strong> {{ item.subType }}</span>
                <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
                <span class="card-text mb-1" v-if="item.massage"><strong>Massage:</strong> {{ item.massage }}</span>
                <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
              </div>
            </div>
          </div>
          <vue-good-table
              v-else
              :columns="declinedTable"
              :rows="report"
              :pagination-options="{ enabled: true, perPage: 10 }"
              styleClass="vgt-table striped bordered condensed"
          >
          </vue-good-table>
        </div>

        <div class="tab-pane fade" id="approved" role="tabpanel" aria-labelledby="profile-tab">
          <div v-if="isMobileView" class="card-container">
            <div class="card col-md-4"
                 style="width: 100%"
                 v-for="(item, index) in report"
                 :key="index"
            >
              <div>
                <div
                    class="manager"
                >
                  <h6 class="h6-tag">APPROVED</h6>
                </div>
                <div class="d-flex flex-row justify-content-between">

                  <div class="d-flex flex-column">
                    <p>{{ item.subType }}</p>
                  </div>
                </div>
                <div class="product-info">
                  <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                </div>
              </div>
              <div class="card-body d-flex flex-column" style="padding: 1px">
                <!--                <button @click="checker(item)">CHECK</button>-->
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
                <span class="card-text mb-1"><strong>Number:</strong> {{ item.reference }}</span>
                <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
                <span class="card-text mb-1"><strong>Processed By:</strong> {{ item.processedBy }}</span>
                <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
                <span class="card-text mb-1" v-if="item.massage"><strong>Massage:</strong> {{ item.massage }}</span>
                <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
              </div>
            </div>
          </div>
          <vue-good-table
              v-else
              :columns="approvedTable"
              :rows="report"
              :pagination-options="{ enabled: true, perPage: 10 }"
              styleClass="vgt-table condensed bordered"
          >
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {VueGoodTable} from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import FloatingAddButton from "@/components/layout/utils/FloatingAddButton.vue";
import {utils as $utils} from "../Services/utils";
import axios from "axios";
import {Storage} from "@/Services/Storage";
import MakeWalletRequest from "@/views/MakeWalletRequest.vue";
import ApproveButton from "@/components/buttons/ApproveButton.vue"
import RangeSelector from "@/components/layout/RangeSelector.vue";

export default {
  components: {RangeSelector, ApproveButton, MakeWalletRequest, FloatingAddButton, VueGoodTable},
  name: "UserRequests",
  computed: {
    totalAmount() {
      return this.filteredCardData.reduce((total, card) => total + (card.amount || 0), 0);
    },
    totalSelectedAmount() {
      return this.refillTableData
          .filter(item => this.selectedIds.includes(item.id))
          .reduce((sum, item) => sum + item.amount, 0);
    },
    $utils() {
      return $utils;
    },
    curUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  created() {
    this.filterCards();
  },
  beforeMount() {
    this.storeSelectedWallet();
    this.getLoggedInUser();
    this.initializeData();

  },
  data() {
    return {
      status2: 'Pending',
      mainSection: true,
      reportSection: false,
      report: [],
      isLoading: false,
      selectAll: false,
      isMobileView: false,
      processingRequests: [],
      mainCards: true,
      massage: '',
      status: false,
      approveAllModal: false,
      showFloatingButton: true, // Controls the visibility of the button
      formData: {},
      activeTab: 'wallet', // Default to 'wallet' tab
      requestsToApprove: [],
      user: {
        Username: 'Null',
        id: 'Null',
        office: '',
        wallets: [],
      },
      reason: '',
      wallets: [],
      selectedWallet: '',
      pettyCashApi: ticketApi2,
      cardData: {
        user: [], // Data for user requests
        wallet: [] // Data for wallet requests
      },
      filteredCardData: [],
      refillTableData: [],
      selectedCard: null,
      denyReason: '', // For storing the reason of denial
      isFetching: false, // Flag to prevent multiple fetches
      sendWallet: '',
      columns2: [
        {label: "ID", field: "id", sortable: true},
        {label: "Type", field: "type", sortable: true},
        {label: "Amount", field: "amount", sortable: true},
        {label: "Reason", field: "reason", sortable: true},
        {label: "Supplier", field: "supplier", sortable: true},
        {label: "Store", field: "storeId", sortable: true},
        {label: "Invoice", field: "invoiceId", sortable: true},
        {label: "Status", field: "status", sortable: true},
        {label: "Massage", field: "massage", sortable: true},
        {label: "State", field: "image", sortable: true},
      ],
      selectedIds: [],
      pendingTable: [
        { label: 'Requested By', field: 'requestBy' },
        { label: 'Reason', field: 'reason' },
        { label: 'Supplier', field: 'supplier' },
        { label: 'Store', field: 'storeId' },
        { label: 'Invoice', field: 'invoiceId' },
        { label: 'Amount', field: 'amount' },
        { label: 'Requested on', field: 'requestDate' },
        { label: 'SubType', field: 'subType' },
        { label: 'Status', field: 'status' },
        { label: 'Manager approved date', field: 'manager_approved_date' },
        // { label: 'Status', field: 'status' },
        // { label: 'Actions', field: 'actions', sortable: false },
      ],
      declinedTable: [
        { label: 'Requested By', field: 'requestBy' },
        { label: 'Reason', field: 'reason' },
        { label: 'Supplier', field: 'supplier' },
        { label: 'Store', field: 'storeId' },
        { label: 'Invoice', field: 'invoiceId' },
        { label: 'Amount', field: 'amount' },
        { label: 'Requested on', field: 'requestDate' },
        { label: 'SubType', field: 'subType' },
        { label: 'Status', field: 'status' },
        { label: 'Manager approved date', field: 'manager_approved_date' },
        { label: 'Declined Reason', field: 'declinedReason' },
        // { label: 'Actions', field: 'actions', sortable: false },
      ],
      approvedTable: [
        { label: 'Requested By', field: 'requestBy' },
        { label: 'Reason', field: 'reason' },
        { label: 'Supplier', field: 'supplier' },
        { label: 'Store', field: 'storeId' },
        { label: 'Invoice', field: 'invoiceId' },
        { label: 'Amount', field: 'amount' },
        { label: 'Requested on', field: 'requestDate' },
        { label: 'SubType', field: 'subType' },
        { label: 'Status', field: 'status' },
        { label: 'Manager approved date', field: 'manager_approved_date' },
        { label: 'Processed By', field: 'processedBy' },
        // { label: 'Actions', field: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    activateMainSection() {
      this.reportSection = false;
      this.mainSection = true;
    },
    activateReportSection() {
      this.mainSection = false;
      this.reportSection = true;
    },
    checker(item) {
      console.log(item);
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Select all IDs
        this.selectedIds = this.refillTableData.map((row) => row.id);
      } else {
        // Deselect all IDs
        this.selectedIds = [];
      }
    },
    processSelected() {
      // Logic for processing selected IDs
      alert(this.selectedIds);
    },
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 768;
    },
    selectionChanged(event) {
      if (event && Array.isArray(event.selectedRows)) {
        this.selectedIds = event.selectedRows.map(row => row.id);
      } else {
        console.error("Unexpected format for selectedRows:", event);
        this.selectedIds = []; // Reset if the input is not valid
      }
    },
    showApproveModal() {
      this.approveAllModal = true;
    },
    closeApproveModal() {
      this.approveAllModal = false;
    },
    openuser() {
      this.$router.push({name: 'SelectRequest'});

    },
    openwallet() {
      this.$router.push({name: 'wallet'});

    },
    async initializeData() {
      await this.getLoggedInUser(); // Ensure user data is fetched first
      await this.getwallets(); // Call getwallets after user data is set
      this.filterCards(); // Fetch and filter cards based on default tab
    },
    closem() {
      const closeButton = document.getElementById('close');
      if (closeButton) {
        closeButton.click();
      }
    },
    getReports() {
      const range = this.$store.getters.getGlobalDateRange;
      this.$utils.showLoading();
      axios.get(`${ticketApi2}ManagerRequestsHistory?managerId=${this.curUser.id}&from=${range.from}&to=${range.to}&status=${this.status2}`)
          .then(response => {
            this.report = response.data;
            console.log(this.report);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          })
          .finally(() => {
            this.$utils.hideLoading();
          })
    },
    async getwallets() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + 'get-all-wallets');
        this.wallets = response.data;
        console.log('Wallets:', this.wallets);

        // Set the first wallet as the default selected wallet
        if (this.wallets.length > 0) {
          // this.selectedWallet = this.wallets[0].id;
          this.filterCards(); // Fetch and filter cards based on the default wallet
        }
      } catch (error) {
        console.error('Error fetching wallets:', error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    async approveAll() {
      if (this.isLoading) return;
      this.isLoading = true;
      const selectedData = this.refillTableData.filter(row =>
          this.selectedIds.includes(row.id)
      );
      const promises = selectedData.map(async (obj, index) => {
        const id = obj.id;
        const approvedBy = this.user.username;
        const url = ticketApi2 + `manager-approve?requestId=${obj.id}&managerUsername=${approvedBy}&newStatus=Pending`
        const requestBody = {
          id: id,
          approvedBy: approvedBy,
          onlyExpense: false,
          status: 'PENDING',
          errorMessage: "",
        };
        return axios.put(url).then(async () => {
          requestBody.status = 'PROCESSED';
          obj.massage = 'Success';
          obj.status = 'PROCESSED';
          this.status = true;

          // Send WhatsApp notification to requester
          try {
            const recipient = obj.requestBy || obj.requestedBy || '';
            const phone = (obj.reference || '').replace(/[+ ]/g, '');
            if (phone) {
              await axios.post('https://wa-api.chrilantech.com/message/sendText/chrilan-admin-billing', {
                number: phone,
                text: `✅ *Petty Cash Approved by Manager*\n\nHi ${recipient},\n\nYour request of *${$utils.formatMoney(obj.amount)}* has been approved by *${approvedBy}*.\n\nIt is now awaiting final approval for funds to be allocated.\n\nReason: ${obj.reason || 'N/A'}`
              }, {
                headers: { 'apikey': '77b4b33203a82eac5fd50c1c98c6e9406d7d18ad4045ea7397e374e9806b37cc' }
              });
            }
          } catch (notifyErr) {
            console.warn('Batch approval WhatsApp notification failed:', notifyErr);
          }
        }).catch(error=>{
          try {
            errorHandler.tomcatError(error, true);
          } catch (e) {
            requestBody.status = 'ERROR';
            // Extract the main error message and the first few lines of the stack trace
            const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
            const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
            requestBody.errorMessage = `${mainErrorMessage}\n${shortStackTrace}`;
            obj.massage = `${mainErrorMessage}\n${shortStackTrace}`;
            obj.status = 'ERROR';
          }
        });
      })
      return Promise.all(promises).finally(() => {
        this.mainCards = true;
        this.filterCards()
        console.log("All API calls completed", this.refillTableData);
        this.isLoading = false
      });
    },
    async AcceptRequest(selectedCard) {
      let recipient = selectedCard.requestBy ? selectedCard.requestBy : selectedCard.requestedBy;
      const approvedBy = this.user.username;
      const url = ticketApi2 + `manager-approve?requestId=${selectedCard.id}&managerUsername=${approvedBy}&newStatus=Pending`;

      return Swal.fire({
        title: 'Are you sure?',
        text: `You are about to authorize ${$utils.formatMoney(selectedCard.amount)} payment to ${recipient}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async () => {
          try {
            await axios.put(url);
            responses.showInfo(`Request Approved Successfully`);

            // Send WhatsApp notification to requester
            try {
              const phone = (selectedCard.reference || '').replace(/[+ ]/g, '');
              if (phone) {
                await axios.post('https://wa-api.chrilantech.com/message/sendText/chrilan-admin-billing', {
                  number: phone,
                  text: `✅ *Petty Cash Approved by Manager*\n\nHi ${recipient},\n\nYour request of *${$utils.formatMoney(selectedCard.amount)}* has been approved by *${approvedBy}*.\n\nIt is now awaiting final approval for funds to be allocated.\n\nReason: ${selectedCard.reason || 'N/A'}`
                }, {
                  headers: { 'apikey': '77b4b33203a82eac5fd50c1c98c6e9406d7d18ad4045ea7397e374e9806b37cc' }
                });
              }
            } catch (notifyErr) {
              console.warn('Manager approval WhatsApp notification failed:', notifyErr);
            }

            return this.filterCards();
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Accept Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;
              return Swal.showValidationMessage('<pre>' + formattedError + '</pre>');
            }
          }
        }
      })
    },


    storeSelectedWallet() {
      if (this.selectedWallet) {
        // localStorage.setItem('selectedWallet', this.selectedWallet);
        this.$store.commit(`setSelectedWallet`, this.selectedWallet)
      }
    },
    async DenyRequest(selectedCard) {
      return Swal.fire({
        icon: `question`,
        title: `Deny Reason`,
        input: `textarea`,
        showCloseButton: true,
        showCancelButton: true,
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async (inputValue) => {
          if (!inputValue) return Swal.showValidationMessage(`Reason is Required`);
          const declinedBy = this.user.username;
          const url = ticketApi2 + `manager-approve?requestId=${selectedCard.id}&managerUsername=${declinedBy}&newStatus=Declined&declineReason=${inputValue}`;

          try {
            await axios.put(url);
            responses.showInfo(`Request Declined Successfully`);
            return this.filterCards();
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Decline Request`);
            } catch (e) {
              const mainErrorMessage = e.message.split('\n')[0];
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n');
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;
              return Swal.showValidationMessage(formattedError);
            }
          }
        }
      })
    },
    async viewticket(selectedCard) {
      const ticket = selectedCard.ticket;
      return window.open(`https://hd.chrilantech.com/ticket/${ticket}`)
    },
    async showPhoto(selectedCard) {
      return window.open(ticketApi2 + `getImageByRequestID/${selectedCard.id}`)
    },
    async acceptRequestOnlyExpense(selectedCard) {
      const id = selectedCard.id; // Get the selected request ID
      const approvedBy = this.user.username;
      // Determine the URL based on the active tab
      const url = this.activeTab === 'wallet'
          ? `${ticketApi2}transaction-handler/approve-wallet-request`
          : `${ticketApi2}transaction-handler/approve-user-request`;

      const requestBody = {
        id: id,
        approvedBy: approvedBy,
        onlyExpense: true
      };
      let recipient = selectedCard.requestBy ? selectedCard.requestBy : selectedCard.requestedBy;
      return Swal.fire({
        title: 'Are you sure?',
        html: `You are about to authorize ${$utils.formatMoney(selectedCard.amount)} payment to ${recipient}<br>
        <span class="text-sm text-primary">NB : This will not make the receivers account , just records the expense</span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async () => {
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Approved Successfully`);
            return this.filterCards(); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Accept Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;
              return Swal.showValidationMessage('<pre>' + formattedError + '</pre>');
            }
          }
        }
      })
    },
    async viewPurchaseOrder(selectedCard) {
      const poNumber = selectedCard.purchaseOrder;
      return window.open(`https://tom9.pos.co.zm/PrintApi/creditor/burntofi_chrilan/printPurchaseOrder?id=${poNumber}&User=Auto`)
    },
    async openimage() {
      if (this.selectedCard) {
        const requestId = this.selectedCard.id; // Get the selected request ID
        const url = ticketApi2 + `getImageByRequestID/${requestId}`;

        try {
          const imageData = ticketApi2 + `getImageByRequestID/${requestId}`; // Assume this contains the image data or URL

          if (imageData) {
            // Show the image in a modal or other component
            Swal.fire({
              title: 'Attached Image',
              imageUrl: imageData, // Set the image URL or data
              confirmButtonText: 'OK'
            });
          } else {
            // Show a message if no image is attached
            Swal.fire({
              title: 'No Image Attached',
              text: 'Sorry, no images were attached to this request.',
              icon: 'info',
              confirmButtonText: 'OK'
            });
          }
        } catch (error) {
          return errorHandler.tomcatError(error)
        }
      } else {
        console.error('No card selected.');
        Swal.fire({
          title: 'Error!',
          text: 'Please select a request first.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    },
    async getLoggedInUser() {
      try {
        this.user = await Storage.getCurrentUser();
        let wallets = this.user.wallets;
        let defaultWallet = null;
        if (wallets && wallets.length > 0) {
          let wallet = wallets.find(wal => wal.primary);
          if (wallet) defaultWallet = wallet.id;
        }
        this.$store.commit(`setSelectedWallet`, defaultWallet);
        this.selectedWallet = defaultWallet;
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },
    async filterCards() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + `Request-by-managerid?managerId=${this.curUser.id}`);
        this.filteredCardData = response.data;
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.$utils.hideLoading();
      }
    },

    logNumber(number) {
      console.log(number);
    },

    async refillVueTable() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + `Request-by-managerid?managerId=${this.curUser.id}`);
        this.refillTableData = response.data;
        this.refillTableData = this.refillTableData.map(obj => ({
          ...obj,
          massage: "",
        }))
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.$utils.hideLoading();
      }
    },
    async setTab(tab) {
      this.activeTab = tab;
      this.filterCards(); // Update cards based on selected tab
    },
    selectCard(item) {
      this.selectedCard = item;
      document.getElementById(`openCard`).click();
    },
    setFallbackImage(event) {
      event.target.src = '/img/no-image.png';
    },
  },
  watch: {
    selectedIds(newVal) {
      // Keep "Select All" checkbox in sync with individual selections
      this.selectAll =
          newVal.length === this.refillTableData.length &&
          this.refillTableData.length > 0;
    },
  },
  mounted() {
    this.filterCards();
    this.checkMobileView();
    window.addEventListener("resize", this.checkMobileView);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobileView);
  }
}
</script>

<style scoped lang="scss">
.manager {
  width: 100%;
  height: fit-content;
  border-radius: 5px;
  background-color: #1d90dd;
  color: white;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.h6-tag {
  margin-top: 5px;
  font-weight: 600;
}
.back-nav {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.range {
  width: 90%;
  display: flex;
  align-items: center;
  overflow-x: auto;
}
.font-btn {
  padding: 5px;
}
.font-btn:hover {
  cursor: pointer;
}
.form-container {
  position: relative;
}
.attention-required {
  color: #ff3c00;
  font-weight: bold;
  animation: flash 1s infinite;
}

@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
}

.hide {
  display: none;
}

.page {
  height: 85vh;
  overflow-y: scroll !important;
  overflow-X: hidden !important;
}

.hidden {
  display: none; /* This will hide the button completely */
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tabs {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.tabs button {
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f8f9fa;
  color: #333;
  padding: 0.5rem 1rem;
  margin-right: 1rem;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.tabs button.active {
  background-color: #007bff;
  color: white;
}

.modal-backdrop {
  z-index: -2 !important;
}


/*===== VARIABLES CSS =====*/
:root {
  --dark-color-lighten: #f2f5ff;
  --red-card: #a62121;
  --blue-card: #4bb7e6;
  --btn: #141414;
  --btn-hover: #3a3a3a;
  --text: #fbf7f7;
}

/*===== CARD =====*/
.container {
  width: 100%;
  max-width: 850px;
  margin: 2rem auto;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.card {
  position: relative;
  padding: 1rem;
  width: 300px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.9rem;
  background-color: var(--red-card);
  color: var(--text);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease;
}

.card-blue {
  background: var(--blue-card);
}

.product-image {
  height: 140px;
  width: 100%;
  overflow: hidden;
  transform: translateY(0);
  transition: transform 500ms ease-in-out;
  filter: drop-shadow(5px 10px 15px rgba(0, 0, 0, 0.3));
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

.card:hover .product-image {
  transform: translateY(-10px) rotate(-3deg);
}

.product-info {
  text-align: center;
}

.product-info h2 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-info p {
  margin: 0.2rem 0;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price {
  font-size: 20px;
  font-weight: 600;
}

.card-body {
  text-align: left;
  font-size: 0.9rem;
  line-height: 1.4;
}

.btn {
  display: flex;
  justify-content: space-between;
  margin-top: 0.8rem;
}

.buy-btn {
  background-color: var(--btn);
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 1rem;
  transition: background-color 300ms ease;
}

.buy-btn:hover {
  background-color: var(--btn-hover);
}

.fav {
  background: #fff;
  padding: 0.5rem;
  border: 1px solid #000;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg {
  height: 25px;
  width: 25px;
  fill: #fff;
  transition: fill 500ms ease;
}

.fav:hover .svg {
  fill: #000;
}

@media screen and (max-width: 768px) {
  .container {
    padding: 1rem;
    flex-direction: column;
  }

  .card {
    width: 90%;
  }

  .product-image {
    height: 150px;
  }
}

.row {
  margin-left: 12px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  width: 95%;
  max-width: 95%;
  max-height: 99vh;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.modal-bodyy {
  flex: 1; /* Makes the body take up remaining space */
  overflow-y: auto; /* Enables vertical scrolling */
  padding: 1rem;
  width: 100%;
}
.modal-header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.div-class {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 400px;
  height: 100px;
  background: aliceblue;
  margin-bottom: 10px;
}

.img {
  width: 40px;
  height: 40px;
}
.card-container {
  width: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);  /* Semi-transparent overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;  /* Ensure it covers the form */
  pointer-events: all;  /* Block interactions */
}
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }

  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }

  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}
</style>
